module.exports = require('./helpers/bundle-url').getBundleURL('3p50z') + "jira.304a1bac.png";